import React, { Component } from "react";
import { connect } from "react-redux";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import TopOfAddStepTables from "../../CellStepManagement/components/TopOfAddStepTables";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FilterListIcon from "@mui/icons-material/FilterList";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import CloseIcon from "@mui/icons-material/Close";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import PrettyDropdown2 from "../../common/components/PrettyDropDown2";
import TablePagination from "../../common/components/Pagination";
import { cachePagesOperations } from "../duck";
import FiltersRow from "../../components/FiltersRow";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HttpService from "../../Dashboard/duck/HttpService";
import Typography from "@mui/material/Typography";
import CachePageFilters from "./CachePageFilters";
import { TablePage } from "../../CellStepManagement/components/TablePage";

class MyCachePages extends Component {
  state = {
    showFilter: false,
    searchTimer: null,
    selectedCachePages: [],
    actionsAnchorEl: null,
    bulkConfirmOpen: false,
    bulkConfirm: null,
    bulkSubmitting: false,
    approvalOverrides: {},
    locationOptions: [{ code: null, description: "All" }],
    languageOptions: [{ code: null, description: "All" }],
    selectedLocationId: null,
  };



  async componentDidMount() {
    this.props.setCachePagesFilters({ approved: true });
    this.props.fetchCachePages({ page_num: 1, approved: true });

    try {
      const locationsRes = await HttpService.getLocationsList();
      const rawLocations = locationsRes?.data?.data || locationsRes?.data || [];

      this.setState({
        locationOptions: [
          { code: null, description: "All" },
          ...rawLocations.map((item) => ({
            code: item.id ?? item.code,
            description: item.description ?? item.name,
          })),
        ],
      });

      await this.fetchLanguageOptions(null);
    } catch (err) {
      console.error("Failed to fetch cache page filter options:", err);
    }
  }

  fetchLanguageOptions = async (locationId = null) => {
    try {
      const languagesRes = locationId
        ? await HttpService.getLanguageList({ locationId })
        : await HttpService.getLanguageList();

      const rawLanguages = languagesRes?.data?.data || languagesRes?.data || [];

      this.setState({
        languageOptions: [
          { code: null, description: "All" },
          ...rawLanguages.map((item) => ({
            code: item.id ?? item.code,
            description: item.description ?? item.name,
          })),
        ],
      });
    } catch (err) {
      console.error("Failed to fetch language options:", err);
      this.setState({
        languageOptions: [{ code: null, description: "All" }],
      });
    }
  };

  componentWillUnmount() {
    if (this.state.searchTimer) clearTimeout(this.state.searchTimer);
  }

  fetchWith = (overrides = {}) => {
    const currentFilters = this.props.filters || {};

    this.props.fetchCachePages({
      ...currentFilters,
      ...overrides,
      page_num:
        overrides.page_num !== undefined ? overrides.page_num : 1,
    });
  };

  handleSearchChange = (val) => {
    this.props.setCachePagesFilters({ search_term: val });

    if (this.state.searchTimer) clearTimeout(this.state.searchTimer);

    const t = setTimeout(() => {
      this.fetchWith({ search_term: val });
    }, 400);

    this.setState({ searchTimer: t });
  };

  handleSortChange = (orderByValue) => {
    this.props.setCachePagesFilters({ order_by: orderByValue });
    this.fetchWith({ order_by: orderByValue });
  };

  handleCachePagesSelection = (ids) => {
    this.setState({ selectedCachePages: ids || [] });
  };

  openActionsMenu = (e) => {
    this.setState({ actionsAnchorEl: e.currentTarget });
  };

  closeActionsMenu = () => {
    this.setState({ actionsAnchorEl: null });
  };

  getRowId = (row) => Number(row?.cachepageid ?? row?.id);

  getRowApproved = (row) => {
    if (!row) return false;

    const direct = row.approved;

    if (typeof direct === "boolean") return direct;
    if (typeof direct === "number") return direct === 1;

    if (typeof direct === "string") {
      const s = direct.trim().toLowerCase();
      if (["1", "true", "t", "yes", "y"].includes(s)) return true;
      if (["0", "false", "f", "no", "n"].includes(s)) return false;
    }

    return false;
  };

  openBulkConfirmDialog = (payload) => {
    this.setState({
      bulkConfirmOpen: true,
      bulkConfirm: payload,
      actionsAnchorEl: null,
    });
  };

  closeBulkConfirmDialog = () => {
    this.setState({ bulkConfirmOpen: false });
  };

  handleBulkConfirmExited = () => {
    this.setState({ bulkConfirm: null, bulkSubmitting: false });
  };

  requestBulkApprovalChange = (approved) => {
    const { selectedCachePages } = this.state;
    if (!selectedCachePages.length) return;

    // Build lookup of currently visible rows
    const rows = this.props.data || [];
    const byId = new Map(rows.map((r) => [this.getRowId(r), r]));

    const isApprovedNow = (id) => this.getApprovedForId(id, byId);

    const skippedIds = [];
    const toUpdateIds = [];

    for (const id of selectedCachePages) {
      // if current state already matches requested state, skip
      if (isApprovedNow(id) === !!approved) skippedIds.push(id);
      else toUpdateIds.push(id);
    }

    const toLabel = (id) => {
      const row = byId.get(Number(id));
      const name = row?.name || row?.cachepage_name || row?.url || `Cache page ${id}`;
      return { id: Number(id), name };
    };

    const row0 = byId.get(Number(selectedCachePages[0]));
    console.log("ROW:", row0);
    console.log("APPROVED?", this.getRowApproved(row0));

    this.openBulkConfirmDialog({
      approved: !!approved,
      toUpdateIds,
      skippedPages: skippedIds.map(toLabel),
      updatedPages: toUpdateIds.map(toLabel),
    });
  };



  confirmBulkApprovalChange = async () => {
    const p = this.state.bulkConfirm;
    if (!p) return;

    const { toUpdateIds = [], approved } = p;
    this.setState({ bulkSubmitting: true });

    try {
      if (toUpdateIds.length) {
        await this.props.bulkUpdateCachePageApproval(toUpdateIds, approved);

        // Patch local truth immediately (so skip logic + UI stays correct)
        this.setState((prev) => {
          const next = { ...(prev.approvalOverrides || {}) };
          toUpdateIds.forEach((id) => {
            next[Number(id)] = !!approved;
          });
          return { approvalOverrides: next };
        });
      }

      await this.props.fetchCachePages({ page_num: this.props.page_num || 1 });
      this.setState({ bulkConfirmOpen: false });
    } catch (err) {
      console.error("Bulk cache page approval update failed:", err);
      this.setState({ bulkSubmitting: false });
    }
  };

  getApprovedForId = (id, byId) => {
    const k = Number(id);
    if (Object.prototype.hasOwnProperty.call(this.state.approvalOverrides, k)) {
      return this.state.approvalOverrides[k];
    }
    return this.getRowApproved(byId.get(k));
  };

  render() {
    const {
      loading,
      data,
      page_num,
      total_page_num,
      results_per_page,
      filters,
    } = this.props;

    const { showFilter, locationOptions, languageOptions } = this.state;


    return (
      <Paper elevation={0} style={{ borderRadius: 16 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "16px",
            alignItems: "center",
          }}
        >
          <TextField
            autoFocus
            onChange={(e) => this.handleSearchChange(e.target.value)}
            value={filters?.search_term || ""}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            label="Search cache pages..."
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "transparent",
                boxShadow: "none",
              },
              "& .MuiOutlinedInput-input": {
                backgroundColor: "transparent !important",
                boxShadow: "none !important",
              },
            }}
          />

          <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
            <Button
              variant="contained"
              size="small"
              endIcon={<KeyboardArrowDownIcon />}
              className={`button-secondary ${!this.state.selectedCachePages?.length ? "disabled" : ""
                }`}
              disabled={!this.state.selectedCachePages?.length}
              onClick={this.openActionsMenu}
              title={
                this.state.selectedCachePages?.length
                  ? "Bulk actions for selected cache pages"
                  : "Select at least one cache page"
              }
            >
              Actions
            </Button>

            <Menu
              anchorEl={this.state.actionsAnchorEl}
              open={!!this.state.actionsAnchorEl}
              onClose={this.closeActionsMenu}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ actionsAnchorEl: null }, () => {
                    this.requestBulkApprovalChange(true);
                  });
                }}
              >
                Approve selected
              </MenuItem>

              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ actionsAnchorEl: null }, () => {
                    this.requestBulkApprovalChange(false);
                  });
                }}
              >
                Unapprove selected
              </MenuItem>
            </Menu>

            <Tooltip placement="bottom" title="Cache Page Filter">
              <IconButton
                onClick={() => this.setState({ showFilter: !showFilter })}
                size="large"
              >
                <FilterListIcon style={{ color: "rgb(99, 115, 129)" }} />
              </IconButton>
            </Tooltip>
          </div>

        </div>

        {showFilter && (
          <div style={{ padding: "0 16px 16px" }}>
            <CachePageFilters
              filters={filters}
              useProvidedOptions
              locationOptions={locationOptions}
              languageOptions={languageOptions}
              onChange={async (updates) => {
                const nextFilters = {
                  ...filters,
                  ...updates,
                };

                if (Object.prototype.hasOwnProperty.call(updates, "location_id")) {
                  this.setState({ selectedLocationId: updates.location_id });
                  await this.fetchLanguageOptions(updates.location_id);
                  nextFilters.language_id = null;
                }

                this.props.setCachePagesFilters(nextFilters);

                this.fetchWith({
                  ...updates,
                  ...(Object.prototype.hasOwnProperty.call(updates, "location_id")
                    ? { language_id: null }
                    : {}),
                  page_num: 1,
                });
              }}
            />
          </div>
        )}

        {loading ? (
          <LoadingSpinner style={{ padding: "25vh", margin: "auto" }} />
        ) : (
          <>
            <div style={{ marginRight: 8 }}>
              <TablePagination
                rowsPerPage={results_per_page}
                onRowsPerPageChange={(e) =>
                  this.fetchWith({
                    results_per_page: Number(e.target.value),
                    page_num: 1,
                  })
                }
                numberOfPages={total_page_num}
                currentPage={page_num}
                onPageChange={(e, newPage) =>
                  this.fetchWith({ page_num: newPage })
                }
              />
            </div>

            <div style={{ padding: "0 16px 16px" }}>
              <TablePage
                loading={loading}
                reusableCachePage={data || []}
                onSelectionChange={this.handleCachePagesSelection}
                handleSortChange={this.handleSortChange}
                currentOrderBy={filters?.order_by || ""}
              // onAddAll={() => {}}
              />
            </div>

            <div style={{ marginRight: 8 }}>
              <TablePagination
                rowsPerPage={results_per_page}
                onRowsPerPageChange={(e) =>
                  this.fetchWith({
                    results_per_page: Number(e.target.value),
                    page_num: 1,
                  })
                }
                numberOfPages={total_page_num}
                currentPage={page_num}
                onPageChange={(e, newPage) =>
                  this.fetchWith({ page_num: newPage })
                }
              />
            </div>
          </>
        )}


        <Dialog
          open={this.state.bulkConfirmOpen}
          onClose={this.closeBulkConfirmDialog}
          maxWidth="sm"
          fullWidth
          disableRestoreFocus
          disableEnforceFocus
          TransitionProps={{ onExited: this.handleBulkConfirmExited }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              pr: 1,
            }}
          >
            <span>
              {this.state.bulkConfirm?.approved ? "Approve cache pages" : "Unapprove cache pages"}
            </span>

            <IconButton
              aria-label="close"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.closeBulkConfirmDialog();
              }}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            {(() => {
              const p = this.state.bulkConfirm;
              if (!p) return null;

              const verb = p.approved ? "approve" : "unapprove";

              return (
                <>
                  <Typography variant="body2" style={{ marginBottom: 12 }}>
                    You are about to {verb} <b>{p.toUpdateIds?.length || 0}</b> cache page(s).
                  </Typography>

                  {p.skippedPages?.length ? (
                    <>
                      <Typography variant="body2" style={{ marginBottom: 8 }}>
                        These will be skipped (already {p.approved ? "approved" : "unapproved"}):
                      </Typography>

                      <List dense>
                        {p.skippedPages.map(({ id, name }) => (
                          <ListItem key={`cp-skipped-${id}`}>
                            {name} ({id})
                          </ListItem>
                        ))}
                      </List>

                      <Divider style={{ margin: "12px 0" }} />
                    </>
                  ) : null}

                  {p.updatedPages?.length ? (
                    <>
                      <Typography variant="body2" style={{ marginBottom: 8 }}>
                        These will be updated:
                      </Typography>

                      <List dense>
                        {p.updatedPages.map(({ id, name }) => (
                          <ListItem key={`cp-updated-${id}`}>
                            {name} ({id})
                          </ListItem>
                        ))}
                      </List>
                    </>
                  ) : (
                    <Typography variant="body2">
                      No updates are needed — everything selected is already{" "}
                      {p.approved ? "approved" : "unapproved"}.
                    </Typography>
                  )}
                </>
              );
            })()}
          </DialogContent>

          <DialogActions>
            <Button
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.closeBulkConfirmDialog();
              }}
              className="button-secondary"
              variant="outlined"
              size="small"
              disabled={this.state.bulkSubmitting}
            >
              Cancel
            </Button>

            <Button
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.confirmBulkApprovalChange();
              }}
              className="button-secondary"
              variant="contained"
              size="small"
              disabled={this.state.bulkSubmitting}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>

      </Paper>
    );
  }
}

const mapStateToProps = (state) => {
  const slice = state.cachePages || {};
  const filters = slice.filters || {};

  return {
    loading: !!slice.loading,
    data: slice.data || [],
    page_num: slice.page_num || 1,
    total_page_num: slice.total_page_num || 1,
    results_per_page: slice.results_per_page || 25,
    filters,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchCachePages: (overrides) =>
    dispatch(cachePagesOperations.fetchCachePages(overrides)),
  setCachePagesFilters: (filters) =>
    dispatch(cachePagesOperations.setCachePagesFilters(filters)),
  bulkUpdateCachePageApproval: (ids, approved) =>
    dispatch(
      cachePagesOperations.bulkUpdateCachePageApproval({
        ids,
        approved,
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyCachePages);
